<template>
    <notification-tray-item-logic ref="item" :item="item" v-slot="{ read, configs, designer, markRead }">
        <div class="notify-item d-flex align-items-center justify-content-between" :class="{'bg-gray-100': !read}"
             @click.prevent="openEvent()" role="button">
            <div class="d-flex align-items-center">
                <div class="me-3">
                    <div class="icon-circle" :class="[designer.background]">
                        <i class="fi d-flex" :class="[designer.color, designer.icon]"></i>
                    </div>
                </div>
                <div>
                    <div class="small text-gray-500"> {{ item.created_at | moment("from", "now") }}</div>
                    <span class="font-weight-bold">{{ item.data.data.title }}</span>
                    <div class="fw-bold" :class="[designer.color]">
                        <span>{{ formatDate(item.data.data) }}</span>
                    </div>
                    <div class="fw-bold" :class="[designer.color]">
                        <plan-action-buttons v-if="plan" :plan="plan" :notification-id="item.id"/>
                    </div>
                </div>
            </div>
            <i v-if="!read" class="fi fi-rr-circle-small text-danger m-l-auto"></i>
        </div>
    </notification-tray-item-logic>
</template>

<script>
import NotificationTrayItemLogic from "./NotificationTrayItemLogic.vue";
import PlanActionButtons from "../../../theme/atoms/PlanActionButtons.vue";
import data from "bootstrap/js/src/dom/data";
import moment from "moment";
import EventView from "../../CalendarWidget/molecules/EventView.vue";
import {eventBus} from "../../../services/EventBus";

export default {
    name: "PlanNotificationTrayItem",
    computed: {
        data() {
            return data
        }
    },
    props: {
        item: Object
    },
    components: {
        NotificationTrayItemLogic,
        PlanActionButtons
    },
    data() {
        return {
            plan: null,
        }
    },
    created() {
        eventBus.$on('eventDataChanged', (data) => {
            if (data.id === this.plan.id) {
                this.plan = data;
            }
        });
    },
    methods: {
        read() {
            axios.post(`/notifications/${this.item.id}/mark-read`)
                .then((response) => {
                    this.$refs.item.read = true;
                    this.$emit('marked-read', this.item)
                });

        },
        formatDate(date) {
            return date.type === 'event' ?
                (
                    date.end ?
                        moment(date.start).format('LLL') + '-' + moment(date.end).format('LT')
                        :
                        moment(date.start).format('MMMM D, YYYY')
                )
                :
                moment(date.start).format('LLLL') + (date.end ? '-' + moment(date.end).format('LT') : '')
        },
        openEvent() {
            window.location.href = `/user-plans/upcoming?date=${moment(this.item.data.data.start).format('YYYY/MM/DD')}`
        },
    },
    mounted() {
        this.plan = this.item?.data?.data
    }
}
</script>
